import { doc, getDoc, getFirestore } from 'firebase/firestore'
import { useUserStore } from '~~/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore()

  // Wait for uid to be available (auth.global.ts ensures we're authenticated already)
  const maxWait = 5000
  const interval = 100
  let waited = 0
  while (!userStore.user.uid && waited < maxWait) {
    await new Promise((resolve) => setTimeout(resolve, interval))
    waited += interval
  }

  if (!userStore.user.uid) {
    return navigateTo('/camera-rolls')
  }

  // Read isAdmin directly from Firestore to avoid race condition with store hydration
  const db = getFirestore()
  const userDoc = await getDoc(doc(db, 'users', userStore.user.uid))
  if (!userDoc.exists() || !userDoc.data()?.isAdmin) {
    console.debug('admin middleware: user is not admin, redirecting to /camera-rolls')
    return navigateTo('/camera-rolls')
  }
})
